package org.multipaz.storage

class KeyExistsStorageException(message: String): StorageException(message)